import type { ComponentType } from 'react';
import { redirect, type RouteObject } from 'react-router-dom';

// Routes.tsx's lazyRoute: the module resolves before the navigation commits.
const lazyPage =
  (load: () => Promise<{ default: ComponentType }>) => async () => ({
    Component: (await load()).default,
  });

/**
 * mcgraw-hill: the partner's pages, plain routes but for the Nursing Courses
 * window. Each page's gate admits only members in McGraw Hill's view.
 */
export const mcgrawHillPlainRoutes: RouteObject[] = [
  // The catalog.
  {
    path: 'mh/:category?',
    lazy: lazyPage(() => import('./McGrawHillPage')),
  },
  // The demo launcher (ORA-1189), where the McGraw Hill logo goes.
  {
    path: 'mh-demos',
    lazy: lazyPage(() => import('./McGrawHillDemosPage')),
  },
  // The Nursing vertical's Courses page (ORA-1261, ORA-1268), in a window.
  {
    path: 'dut/courses',
    lazy: lazyPage(() => import('./DutCoursesPage')),
    handle: {
      os: { variant: 'default', windowGroup: 'dut-courses', title: 'Courses' },
    },
  },
  // The retired course demo (ORA-1175 → ORA-1247): old links land home.
  { path: 'mh-course/*', loader: () => redirect('/') },
];
